import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProofSection } from '../components/ProofSection';
import { ProblemSection } from '../components/ProblemSection';
import { SystemSection } from '../components/SystemSection';
import { ModulesSection } from '../components/ModulesSection';
import { PreviewSection } from '../components/PreviewSection';
import { BonusSection } from '../components/BonusSection';
import { UrgencySection } from '../components/UrgencySection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-hidden bg-white" data-id="element-288" data-mp="ln7ag3ngcsb6">
      <HeroSection data-id="element-289" data-mp="2zjq7jvjbv173" />
      <ProofSection data-id="element-290" data-mp="2zk88v6kuk5lv" />
      <ProblemSection data-id="element-291" data-mp="2zkrqsnahytzw" />
      <SystemSection data-id="element-292" data-mp="33kihkr00xa4f" />
      <ModulesSection data-id="element-293" data-mp="33k0k5r1mkpux" />
      <PreviewSection data-id="element-294" data-mp="33lbq9xijm9p7" />
      <BonusSection data-id="element-295" data-mp="33ksaongd7xec" />
      <UrgencySection data-id="element-296" data-mp="38jln0cjx1icx" />
      <PricingSection data-id="element-297" data-mp="38j3gmn3jhnra" />
      <TestimonialsSection data-id="element-298" data-mp="38itpgw6rdak0" />
      <GuaranteeSection data-id="element-299" data-mp="38himuzp1u8uh" />
      <FAQSection data-id="element-300" data-mp="3dabubvbwjva9" />
      <FinalCTA data-id="element-301" data-mp="3dav6swis9rgw" />
      <Footer data-id="element-302" data-mp="3dbdcejrc5i1h" />
      <PurchasePopup data-id="element-303" data-mp="3dbwk77n9uq1s" />
    </main>;
}